import List from './List';
import Show from './Show';
import New from './New';

export default {
  List,
  Show,
  New,
};
